/** Kanban column keys stored on agile `tasks` documents. */
export const AGILE_TASK_STATUSES = [
  { id: 'todo', label: 'To Do' },
  { id: 'in_progress', label: 'In Progress' },
  { id: 'review', label: 'Review' },
  { id: 'done', label: 'Done' },
];

export const AGILE_TASK_TYPES = [
  { id: 'feature', label: 'Feature' },
  { id: 'bug', label: 'Bug' },
  { id: 'task', label: 'Task' },
];

export function statusLabel(statusId) {
  return AGILE_TASK_STATUSES.find((s) => s.id === statusId)?.label || statusId || '—';
}

export function typeLabel(typeId) {
  return AGILE_TASK_TYPES.find((t) => t.id === typeId)?.label || typeId || '—';
}

export const DEFAULT_AGILE_STATUS = 'todo';
export const DEFAULT_AGILE_TYPE = 'task';
